import React from "react";

function ContactCta({ className = "" }) {
	const imageSrc = (path) => process.env.PUBLIC_URL + path;

	return (
		<div
			className={`flex flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-[0_8px_30px_rgba(0,0,0,0.08)] md:flex-row ${className}`}
		>
			<div className="flex flex-1 flex-col justify-center px-6 py-8 md:px-10 md:py-10 lg:px-12">
				<h3 className="text-2xl font-bold text-gray-900 md:text-[32px] md:leading-tight">
					Ready for a quote or more information?
				</h3>
				<p className="mt-3 max-w-md text-sm leading-relaxed text-gray-500 md:text-[15px]">
					Call now to get a quote or for more information. Tell us
					about your barn and we&apos;ll recommend the right
					ventilation, curtains, and layout for your herd.
				</p>
				<a
					href="tel:715-255-2355"
					className="mt-6 flex w-fit items-center gap-3"
				>
					<span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary text-white">
						<i
							className="fa-solid fa-phone text-sm"
							aria-hidden="true"
						></i>
					</span>
					<span className="text-left">
						<span className="block text-[11px] font-semibold tracking-[0.16em] text-primary">
							CALL NOW
						</span>
						<span className="block text-xl font-bold text-gray-900 md:text-2xl">
							715-255-2355
						</span>
					</span>
				</a>
			</div>
			<div className="p-5 md:w-[44%] md:p-6 lg:p-7">
				<img
					className="h-52 w-full rounded-xl object-cover md:h-full"
					src={imageSrc("/images/hero-desktop (2).png")}
					alt="Dairy cows feeding in a ventilated barn"
				/>
			</div>
		</div>
	);
}

export default ContactCta;
